import { render, staticRenderFns } from "./OrderManagementScreen.vue?vue&type=template&id=8369072c&scoped=true&"
import script from "./OrderManagementScreen.vue?vue&type=script&lang=ts&"
export * from "./OrderManagementScreen.vue?vue&type=script&lang=ts&"
import style0 from "./OrderManagementScreen.vue?vue&type=style&index=0&id=8369072c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8369072c",
  null
  
)

export default component.exports